import { Injectable } from "@angular/core";
import { CalculationBaseStoreService } from "../calculation-base/calculation-base.store.service";
import { BalanceByAccountsCalculatedCollection } from "@bitwarden/web-vault/app/services/store/calculation-today/balances/balance-by-accounts.calculated.collection";
import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import {
  BalanceCalculatedTodayAdapterType,
  CalculatedBalanceParams,
  CalculatedTodayStoreAdapterInterface,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";
import { BalanceCurrentCalculatedCollection } from "@bitwarden/web-vault/app/services/store/calculation-today/balances/balance-current.calculated.collection";

@Injectable({
  providedIn: "root",
})
export class CalculationTodayStoreService
  extends CalculationBaseStoreService
  implements CalculatedTodayStoreAdapterInterface<BalanceCalculatedTodayAdapterType>
{
  balanceByAccount = new BalanceByAccountsCalculatedCollection();
  balanceCurrent = new BalanceCurrentCalculatedCollection();

  protected clearBalanceCollections(): void {
    this.balanceByAccount.clear();
    this.balanceCurrent.clear();
  }

  async updateBalanceCalculations(
    calculatedGeneratedTransactions: TransactionView[],
  ): Promise<void> {
    const parameters: CalculatedBalanceParams = {
      calculatedTransactions: calculatedGeneratedTransactions,
      webWorkerQueue: this.webWorkerQueue,
      filter: this.filters.selected(),
      group: this.groupings.selected(),
      period: this.period.selected(),
    };

    const promises: Promise<void>[] = [];

    promises.push(this.balanceByAccount.updateCalculations(parameters));
    promises.push(this.balanceCurrent.updateCalculations(parameters));

    await Promise.all(promises);
    return;
  }

  protected async updateCalculation() {
    this.appState.startProcess("balance-calculation-today", "Calculating Balances...");
    await super.updateCalculation();
    this.appState.endProcess("balance-calculation-today");
  }
}
